import { MouseEvent, PropsWithChildren, forwardRef, useCallback } from 'react';
import { useUser } from 'client/lib/User';
import { useClaimAccount } from 'client/components/Dialog/ClaimAccountDialog';
import { Button, ButtonProps } from './Button';

export const ButtonWithTrialBlock = forwardRef<HTMLButtonElement, PropsWithChildren<ButtonProps>>((props, ref) => {
  const { user } = useUser();
  const { open } = useClaimAccount();
  const isAnonymousTrial = user && !!user.anonymousTrial;

  let href = props.href;
  if (isAnonymousTrial) href = undefined;

  const handleClick = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      if (isAnonymousTrial) open();
      if (!isAnonymousTrial && props.onClick) props.onClick(event);
    },
    [isAnonymousTrial, props.onClick]
  );

  return <Button {...props} href={href} onClick={handleClick} />;
});
